import { combineReducers } from 'redux';
import showUIReducer from './showUIReducer';

export default combineReducers({
  showParts: showUIReducer
});